var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.order ? _c(_vm.order.paymentGateway, {
    ref: "pg",
    tag: "component",
    attrs: {
      "order": _vm.order
    }
  }) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }